import { inject } from '@angular/core';
import type { Technology } from '@indutrust/shared-model';
import {
  withCrudEntitiesEvents,
  withLoadAllOnAuthEvents,
  withOrderedEntities,
} from '@indutrust/shared-util';
import { signalStore } from '@ngrx/signals';
import { TechnologyApiClient } from '../technology-api-client.service';
import { technologyCrudEvents } from './technology.events';

/**
 * Signal store managing {@link Technology} entities and their loading lifecycle.
 *
 * Provides ordered entities, selection helpers, and event-driven CRUD operations via {@link withCrudEntitiesEvents}.
 * API calls are automatically handled through the service factory passed to withCrudEntitiesEvents.
 *
 * @example
 * import { inject } from '@angular/core';
 * import { TechnologyStore } from '@indutrust/shared-data';
 *
 * class Example {
 *   protected readonly technologyStore = inject(TechnologyStore);
 *   // Auto-loads on auth via withLoadAllOnAuthEvents — read entitiesOrdered() in the template.
 * }
 */
export const TechnologyStore = signalStore(
  { providedIn: 'root' },
  withCrudEntitiesEvents<Technology>(technologyCrudEvents, () =>
    inject(TechnologyApiClient)
  ),
  withLoadAllOnAuthEvents(technologyCrudEvents),
  withOrderedEntities<Technology>()
);
